module.exports = __webpack_public_path__ + "img/chipping7.bf3bd89b.png";